"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserGroups = exports.getUserProfile = exports.selectParticipantId = exports.selectUser = void 0;
var types_1 = require("../../types");
var selectUser = function (_a) {
    var user = _a.user;
    return user.data;
};
exports.selectUser = selectUser;
var selectParticipantId = function (_a) {
    var user = _a.user;
    return user.data.participantId;
};
exports.selectParticipantId = selectParticipantId;
var getUserProfile = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var appConfigs = _a.appConfigs, user = _a.user;
    var firstName = (_b = user.data) === null || _b === void 0 ? void 0 : _b.participant.firstName;
    var lastName = (_c = user.data) === null || _c === void 0 ? void 0 : _c.participant.lastName;
    var nickname = (_d = user.data) === null || _d === void 0 ? void 0 : _d.participant.nickname;
    var nicknameWithQuotes = nickname && "\"" + nickname + "\"";
    var userInitials = firstName &&
        lastName &&
        "" + firstName[0].toUpperCase() + lastName[0].toUpperCase();
    return {
        adfsEnabled: ((_e = appConfigs[types_1.ApplicationConfigKey.clientConfig]) === null || _e === void 0 ? void 0 : _e.properties.adfsEnabled) ||
            false,
        email: (_f = user.data) === null || _f === void 0 ? void 0 : _f.participant.email,
        firstName: firstName,
        groups: ((_g = user.data) === null || _g === void 0 ? void 0 : _g.clientGroups) || [],
        imageUrl: (_h = user.data) === null || _h === void 0 ? void 0 : _h.imageUrl,
        langKey: (_j = user.data) === null || _j === void 0 ? void 0 : _j.langKey,
        lastName: lastName,
        name: firstName + " " + nicknameWithQuotes + " " + lastName,
        nameWithoutNick: firstName + " " + lastName,
        nickname: ((_k = user.data) === null || _k === void 0 ? void 0 : _k.participant.nickname) || "",
        primaryGroupId: (_l = user.data) === null || _l === void 0 ? void 0 : _l.primaryGroupId,
        supervisor: (_o = (_m = user.data) === null || _m === void 0 ? void 0 : _m.supervisor) === null || _o === void 0 ? void 0 : _o.fullName,
        userInitials: userInitials,
        workLocationId: (_q = (_p = user.data) === null || _p === void 0 ? void 0 : _p.workLocation) === null || _q === void 0 ? void 0 : _q.id,
    };
};
exports.getUserProfile = getUserProfile;
var getUserGroups = function (_a) {
    var _b;
    var user = _a.user;
    return ((_b = user.data) === null || _b === void 0 ? void 0 : _b.clientGroups) || [];
};
exports.getUserGroups = getUserGroups;
//# sourceMappingURL=user.selectors.js.map